import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {MessengerModule} from '../messenger/messenger.module';
import {BreadcrumbsModule} from './components/breadcrumbs/breadcrumbs.module';
import {LoadingModule} from './components/loading/loading.module';
import {LogoModule} from './components/logo/logo.module';
import {PaginationModule} from './components/pagination/pagination.module';
import {PipesModule} from './pipes/pipes.module';
import {StorageLinkModule} from './storage-link/storage-link.module';

const SHARED_MODULES = [
    CommonModule,
    NgbModule,
    MessengerModule,

    BreadcrumbsModule,
    LogoModule,
    LoadingModule,
    PaginationModule,

    PipesModule,
    StorageLinkModule,
];

@NgModule({
    imports: [
        CommonModule,
        NgbModule.forRoot(),
        MessengerModule.forRoot(),

        BreadcrumbsModule.forRoot(),
        LogoModule,
        LoadingModule,
        PaginationModule,

        PipesModule,
        StorageLinkModule,
    ],
    exports: SHARED_MODULES
})
export class SharedRootModule {
}

@NgModule({
    imports: SHARED_MODULES,
    exports: SHARED_MODULES
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedRootModule,
            providers: []
        };
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/shared.module.ts